// src/pages/Dashboard.jsx

import React, { useState } from 'react';
import { WebLayout } from 'components/Layout';
import { useAuth } from 'lib/auth';
import { motion } from 'framer-motion';

import { OwnerDashboard } from '../components/OwnerDashboard';
import { WorkerDashboard } from '../components/WorkerDashboard';
import { GeneralUserDashboard } from '../components/GeneralUserDashboard';
import { PlatformAdminDashboard } from '../components/PlatformAdminDashboard';
import { Button } from 'components/Elements';

export const Dashboard = () => {
  const { user } = useAuth();

  // Extract admin phones from environment variable
  const adminPhones = process.env.REACT_APP_ADMIN_PHONES?.split(',').map((p) => p.trim()) || [];

  const isAdminUser = user?.role === 'admin' || adminPhones.includes(user?.phone);

  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <WebLayout>
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="flex flex-row items-center justify-between">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <h1 className="text-xl md:text-4xl font-extrabold text-gray-900 dark:text-gray-100 tracking-tight">
              👋 Welcome back,{' '}
              <span className="text-fundo-green-700 dark:text-fundo-green-400">
                {user?.name || 'Farmer'}
              </span>
            </h1>

            <p className="text-gray-600 dark:text-gray-400 mt-2 text-lg md:text-xl">
              Here's an overview of your farm activity and important actions.
            </p>
          </motion.div>
          {isAdminUser && (
            <div className="mb-8">
              <Button
                variant={showAdmin ? 'secondary' : 'outline'}
                onClick={() => setShowAdmin((prev) => !prev)}
              >
                {showAdmin ? 'Hide Advanced Dashboard' : 'Enable Advanced Dashboard'}
              </Button>
            </div>
          )}
        </div>

        {/* ADMIN DASHBOARD */}
        {isAdminUser && showAdmin ? (
          <PlatformAdminDashboard user={user} />
        ) : (
          <>
            {/* FARM OWNER */}
            {user?.role === 'farm_owner' && <OwnerDashboard user={user} />}

            {/* WORKER */}
            {user?.role === 'worker' && <WorkerDashboard user={user} />}

            {/* REGULAR USER */}
            {user?.role === 'user' && <GeneralUserDashboard user={user} />}
          </>
        )}
      </div>
    </WebLayout>
  );
};
